import React from 'react';
import { BrowserRouter, Switch, Route } from 'react-router-dom';
import NewItem from "./Components/Items/NewItem";
import Landing from "./Components/Landing";
import Auth from "./Components/Auth";
import "antd/dist/antd.css";
import Items from "./Components/Items";
import Shops from "./Components/Shop";
import NewShop from "./Components/Shop/NewShop";
import Shop from "./Components/Shop/Shop";
import CustomMap from "./Components/Map/Map";
import Terms from "./Components/Terms/Terms";
import Policy from "./Components/Terms/Policy";
import Job from "./Components/Terms/Job";
import Navbar from "./Components/Layout/Navbar";
import CustomFooter from "./Components/Layout/Footer";
import About from "./Components/Terms/About";
import Admin from "./Components/Admin";
import "./index.css"

class App extends React.Component {

    render() {

        console.log(this.props);

        return (
            <div>
                <BrowserRouter>
                    <div>
                        <Navbar />
                        <Switch>
                            <Route exact path="/" component = { Landing } />
                            <Route exact path="/auth" component = { Auth } />
                            <Route exact path="/items" component = { Items } />
                            <Route exact path="/shops" component = { Shops } />
                            <Route exact path="/shops/new" component = { NewShop } />
                            <Route exact path="/shops/:id" component = { Shop } />
                            <Route exact path="/map" component = { CustomMap } />
                            <Route exact path="/terms" component = { Terms } />
                            <Route exact path="/policy" component = { Policy } />
                            <Route exact path="/jobs" component = { Job } />
                            <Route exact path="/about" component = { About } />
                            <Route exact path="/admin" component = { Admin } />
                        </Switch>
                        <CustomFooter/>
                    </div>
                </BrowserRouter>
            </div>
        );
    }
}

export default App;



// WEBPACK FOOTER //
// ./src/App.js